import React from 'react'
import { useIntl } from 'react-intl'
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { ui } from '../../../utils/uiTokens'

const GRADES = Array.from({ length: 11 }, (_, i) => i + 1)
// Все буквы казахского алфавита, кроме Ъ и Ь; '' - класс без литера
const LITERALS = ['', ...'АӘБВГҒДЕЁЖЗИЙКҚЛМНҢОӨПРСТУҰҮФХҺЦЧШЩЫІЭЮЯ'.split('')]

interface Props {
    grade: number
    literal: string
    onChange: (grade: number, literal: string) => void
}

const buttonSx = {
    minWidth: 36,
    height: 36,
    px: 1,
    fontWeight: 600,
    border: `1px solid ${ui.border} !important`,
    borderRadius: '10px !important',
    color: ui.ink,
    '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: ui.pink, color: '#fff' },
}

const groupSx = { display: 'flex', flexWrap: 'wrap', gap: 0.5 }

// Класс и литер выбираются кнопками в один клик, без ввода текста
const ClassPicker: React.FC<Props> = ({ grade, literal, onChange }) => {
    const { formatMessage } = useIntl()
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box>
                <Box sx={{ fontSize: '13px', fontWeight: 600, color: ui.sub, mb: 0.75 }}>{formatMessage({ id: 'grade' })}</Box>
                <ToggleButtonGroup exclusive value={grade || null} sx={groupSx}
                    onChange={(e, v) => v && onChange(v, literal)}>
                    {GRADES.map((g) => <ToggleButton key={g} value={g} sx={buttonSx}>{g}</ToggleButton>)}
                </ToggleButtonGroup>
            </Box>
            <Box>
                <Box sx={{ fontSize: '13px', fontWeight: 600, color: ui.sub, mb: 0.75 }}>{formatMessage({ id: 'schoolLiteral' })}</Box>
                <ToggleButtonGroup exclusive value={literal} sx={groupSx}
                    onChange={(e, v) => v !== null && onChange(grade, v)}>
                    {LITERALS.map((l) => <ToggleButton key={l || 'none'} value={l} sx={buttonSx}>{l || '—'}</ToggleButton>)}
                </ToggleButtonGroup>
            </Box>
        </Box>
    )
}

export default ClassPicker
